import { render, staticRenderFns } from "./suspendedtickets.vue?vue&type=template&id=6fb7280e&"
import script from "./suspendedtickets.vue?vue&type=script&lang=js&"
export * from "./suspendedtickets.vue?vue&type=script&lang=js&"
import style0 from "./suspendedtickets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports